// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4ac3baf1","732":"e1b47dbe"}[chunkId] + ".chunk.js";
};